import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { AddAdminDocument, AllAdminsDocument } from 'graphql/generated/graphql';

const useAssignAdmin = () => {
  const [assignAdminMutation] = useMutation(AddAdminDocument);

  const handleAssign = useCallback(
    async (email: { email: string }) => {
      try {
        await assignAdminMutation({
          variables: email,
          refetchQueries: [{ query: AllAdminsDocument }],
          awaitRefetchQueries: true,
        });
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [assignAdminMutation],
  );

  return handleAssign;
};

export default useAssignAdmin;
